@if (display()) {
  <article @fadeInOut class="headband" [attr.type]="type()">
    <section class="headband__header">
      @switch (type()) {
        @case ('warning') {
          <svg class="headband__header__ico" xmlns="http://www.w3.org/2000/svg" width="1.25em" height="1.25em" viewBox="0 0 32 32">
            <g fill="none" stroke="currentColor">
              <path
                stroke-linecap="round"
                stroke-width="2"
                d="M16 18v-6M6.358 27h19.284c1.516 0 2.48-1.62 1.759-2.953l-9.642-17.8c-.757-1.397-2.761-1.397-3.518 0L4.6 24.047C3.877 25.38 4.842 27 6.358 27Z"
              />
              <path fill="currentColor" d="M17 21.5a1 1 0 1 1-2 0a1 1 0 0 1 2 0Z" />
            </g>
          </svg>
        }
        @case ('success') {
          <svg class="headband__header__ico" xmlns="http://www.w3.org/2000/svg" width="1.25em" height="1.25em" viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8s8 3.59 8 8s-3.59 8-8 8m4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4l8-8z"
            />
          </svg>
        }
        @default {
          <svg class="headband__header__ico" xmlns="http://www.w3.org/2000/svg" width="1.25em" height="1.25em" viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M12 14a1.25 1.25 0 1 0 1.25 1.25A1.25 1.25 0 0 0 12 14m0-1.5a1 1 0 0 0 1-1v-3a1 1 0 0 0-2 0v3a1 1 0 0 0 1 1M12 2a10 10 0 1 0 10 10A10.011 10.011 0 0 0 12 2m0 18a8 8 0 1 1 8-8a8.01 8.01 0 0 1-8 8"
            />
          </svg>
        }
      }
      <h2 class="text--bold text--md">{{ title() }}</h2>
    </section>
    <p class="headband__body text--sm text--regular">
      {{ content() }}
    </p>
    <section class="headband__footer">
      @if (!!secondaryBtnLabel()) {
        <button (click)="onCLick(false)">{{ secondaryBtnLabel() }}</button>
      }
      <button (click)="onCLick(true)">
        {{ primaryBtnLabel() }}
        <svg xmlns="http://www.w3.org/2000/svg" width="1.25em" height="1.25em" viewBox="0 0 24 24">
          <path
            fill="currentColor"
            d="M12.293 5.293a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414-1.414L16.586 13H5a1 1 0 1 1 0-2h11.586l-4.293-4.293a1 1 0 0 1 0-1.414"
          />
        </svg>
      </button>
    </section>
    <svg
      (click)="onClose()"
      class="cross clickable"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      aria-hidden="true"
      role="img"
      width="25px"
      height="25px"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 24 24"
    >
      <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41z" />
    </svg>
  </article>
}
